// extracted by mini-css-extract-plugin
export default {"fleet":"Fleet_fleet__XD3Aj","title":"Fleet_title__xHicb","container":"Fleet_container__COS30","empty":"Fleet_empty__nSXOb"};